export const filter = {
  user_id: '',
  warehouse_id: '',
  mainwarehouse_id: '',
  created_at: '',
  updated_at: ''
};